import { z } from 'zod';
import { CreateProcessDraftResponseSchema, DiscardProcessDraftResponseSchema, GetProcessDraftResponseSchema, UndoRedoDraftResponseSchema } from './process-draft.schema';
export const getProcessDraftContract = {
    method: 'GET',
    path: '/api/v2/process/:processId/draft',
    description: 'Fetch the current draft (and its steps) for a process',
    responseSchema: GetProcessDraftResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Draft not found'
        }
    }
};
export const createProcessDraftContract = {
    method: 'POST',
    path: '/api/v2/process/:processId/draft',
    description: 'Create a new draft seeded from the current live process',
    requestSchema: z.object({}),
    responseSchema: CreateProcessDraftResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Process not found',
            409: 'Draft already exists'
        }
    }
};
export const discardProcessDraftContract = {
    method: 'DELETE',
    path: '/api/v2/process/:processId/draft',
    description: 'Discard the current draft (deletes draft + draft steps)',
    responseSchema: DiscardProcessDraftResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Draft not found'
        }
    }
};
export const undoProcessDraftContract = {
    method: 'POST',
    path: '/api/v2/process/:processId/draft/undo',
    description: 'Step the draft back one entry in its persistent history (ADR 0007)',
    requestSchema: z.object({}),
    responseSchema: UndoRedoDraftResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Draft not found',
            409: 'History changed concurrently — refetch the draft'
        }
    }
};
export const redoProcessDraftContract = {
    method: 'POST',
    path: '/api/v2/process/:processId/draft/redo',
    description: 'Step the draft forward one entry in its persistent history (ADR 0007)',
    requestSchema: z.object({}),
    responseSchema: UndoRedoDraftResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Draft not found',
            409: 'History changed concurrently — refetch the draft'
        }
    }
};

//# sourceMappingURL=process-draft.contract.js.map